import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { uploadVehicleNumbers } from "../../../api/Competitions";
import { Spinner } from 'react-bootstrap';

function UploadVehicleNumbersModal({ competitionId, onHide, show, onSuccess, ...props }) {
  const [file, setFile] = useState();
  const [errors, setErrors] = useState({});
  const [isUploading, setIsUploading] = useState(false);

  const FILE_FORMAT_NAME = 'CSV';
  const FILE_FORMAT_TYPE = 'text/csv';

  useEffect(() => {
    setFile();
    setErrors({});
  }, [show]);

  const findFormErrors = () => {
    const newErrors = {};
    // file errors
    if (!file) {
      newErrors.file = 'Du måste välja en fil.';
    } else if (file.type !== FILE_FORMAT_TYPE) {
      newErrors.file = `Endast tillåtet filformat ${FILE_FORMAT_NAME}.`;
    } else if (file.size > 2048000) {
      newErrors.file = 'Filen är för stor. Maximal filstorlek 2 MB.';
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const formData = new FormData();
    formData.append('competitionId', competitionId);
    formData.append('file', file);

    setIsUploading(true);
    uploadVehicleNumbers(formData)
      .then(() => {
        onSuccess();
        onHide();
      })
      .catch((err) => {
        setErrors({ upload: err.message });
      })
      .finally(() => setIsUploading(false));
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      {...props}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>Ladda upp fordonsnummer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} id='upload-vehicle-numbers-form'>
          <p>Giltigt filformat {FILE_FORMAT_NAME}. Maximal filstorlek 2 MB.</p>
          <Form.Group className='mt-2'>
            <Form.Control
              type='file'
              multiple={false}
              accept={FILE_FORMAT_TYPE}
              onChange={(e) => setFile(e.target.files[0])}
              isInvalid={!!errors.file}
              disabled={isUploading}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.file}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        {!!errors.upload &&
          <p className='w-100 small text-danger-dark text-end'>{errors.upload}</p>
        }
        <Button onClick={onHide} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button type='submit' form='upload-vehicle-numbers-form' disabled={isUploading}>
          {isUploading ? (
            <>
              <Spinner
                as='span'
                animation='border'
                size='sm'
                role='status'
                aria-hidden='true'
                className='me-2'
              />
              <span className='visually-hidden'>Loading...</span>
              Laddar upp...
            </>
          ) : (
            'Ladda upp'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default UploadVehicleNumbersModal;
